// storage.ts
/**
 * 存储数据
 */
export const setItem = (key: string, value: any) => {
  // value 分为两种
  // 1.基础类型
  // 2.复杂类型
  if (typeof value === 'object') {
    value = JSON.stringify(value)
  }
  window.localStorage.setItem(key, value)
}

/**
 * 获取数据
 */
export const getItem = (key: string): any => {
  try {
    const data = window.localStorage.getItem(key)
    console.log('getItem', data)
    // return data != null ? JSON.parse(data) : null
    return data != null ? data: null
  } catch (err) {
    console.log('getItem', err)
    return null
  }
}

/**
 * 删除指定数据
 */
export const removeItem = (key: string) => {
  window.localStorage.removeItem(key)
}

/**
 * 删除所有数据
 */
export const removeAllItem = () => {
  window.localStorage.clear()
}
